import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Edit = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.27614 9.5935L9.03753 2.83207L8.09473 1.88926L1.33333 8.6507V9.5935H2.27614ZM2.82843 10.9268H0V8.09843L7.62333 0.47505C7.88373 0.214697 8.3058 0.214697 8.56613 0.47505L10.4518 2.36066C10.7121 2.62102 10.7121 3.04312 10.4518 3.30348L2.82843 10.9268ZM0 12.2602H12V13.5935H0V12.2602Z"
        fill={color ?? theme.palette.primary.main}
      />
    </svg>
  );
};

export default Edit;
